module.exports = __webpack_public_path__ + "static/media/chandrahas_DGl02m5rl.c62fe84b.jpg";